import { NgxMatDatetimePickerModule } from '@angular-material-components/datetime-picker';
import { NgxMatMomentModule } from '@angular-material-components/moment-adapter';
import { A11yModule } from '@angular/cdk/a11y';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { LayoutModule } from '@angular/cdk/layout';
import { PortalModule } from '@angular/cdk/portal';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CdkStepperModule } from '@angular/cdk/stepper';
import { CdkTableModule } from '@angular/cdk/table';
import { CdkTreeModule } from '@angular/cdk/tree';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortHeaderIntl, MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';
import { MatDatetimepickerModule, MatNativeDatetimeModule } from '@mat-datetimepicker/core';
import { PhoneNumberModule } from 'src/app/shared/directives/phone-number/phone-number.module';
import { CloseMatDialogModule } from './close-mat-dialog/close-mat-dialog.module';
import { DebounceClickModule } from './directives/debounce-click/debounce-click.module';
import { MatRowKeyboardSelectionModule } from './directives/mat-row-keyboard-selection/mat-row-keyboard-selection.module';
import { NumberOnlyModule } from './directives/number-only/number-only.module';
import { SaveHotkeyModule } from './directives/save-hotkey/save-hotkey.module';
import { CustomMatSortHeaderIntl } from './utility/custom-mat-sort-header-intl';
import { AnnounceSortChangeModule } from './directives/announce-sort-change/announce-sort-change.module';
import { AnnounceTooltipModule } from './directives/announce-tooltip/announce-tooltip.module';
@NgModule({
	exports: [
		A11yModule,
		CdkStepperModule,
		CdkTableModule,
		CdkTreeModule,
		DragDropModule,
		MatAutocompleteModule,
		MatBadgeModule,
		MatBottomSheetModule,
		MatButtonModule,
		MatButtonToggleModule,
		MatCardModule,
		MatCheckboxModule,
		MatChipsModule,
		MatStepperModule,
		MatDatepickerModule,
		MatDialogModule,
		MatDividerModule,
		MatExpansionModule,
		MatGridListModule,
		MatIconModule,
		MatInputModule,
		MatListModule,
		MatMenuModule,
		MatNativeDateModule,
		MatNativeDatetimeModule,
		MatDatetimepickerModule,
		MatPaginatorModule,
		MatProgressBarModule,
		MatProgressSpinnerModule,
		MatRadioModule,
		MatRippleModule,
		MatSelectModule,
		MatSidenavModule,
		MatSliderModule,
		MatSlideToggleModule,
		MatSnackBarModule,
		MatSortModule,
		MatTableModule,
		MatTabsModule,
		MatToolbarModule,
		MatTooltipModule,
		MatTreeModule,
		MatToolbarModule,
		PortalModule,
		ScrollingModule,
		LayoutModule,
		FlexLayoutModule,
		ReactiveFormsModule,
		PhoneNumberModule,
		MatRowKeyboardSelectionModule,
		DebounceClickModule,
		NgxMatDatetimePickerModule,
		NgxMatMomentModule,
		CloseMatDialogModule,
		SaveHotkeyModule,
		NumberOnlyModule,
		AnnounceSortChangeModule,
		AnnounceTooltipModule,
	],
	schemas: [
        CUSTOM_ELEMENTS_SCHEMA
      ],
	imports: [
		PhoneNumberModule,
		DebounceClickModule,
		MatIconModule,
		FormsModule,
		ReactiveFormsModule,
		CloseMatDialogModule,
		SaveHotkeyModule,
		NumberOnlyModule,
		AnnounceSortChangeModule,
		AnnounceTooltipModule,
	],
	providers: [{ provide: MatSortHeaderIntl, useClass: CustomMatSortHeaderIntl }],
})
export class SharedMaterialModule {}
